import apiClient from './apiClient';

/**
 * Card guarantee charging (Channex Payment Application).
 *
 * The hotel connects its OWN Stripe account through a Stripe OAuth link that
 * the backend fetches from Channex; FrontDesko never holds keys, cards or
 * money. `connect` returns the link to send the owner to; `refresh` re-reads
 * the connected providers once they are back on this page.
 */
const cardGuaranteeService = {
  getStatus: () => apiClient.get('/v1/settings/card-guarantee'),
  connect: (redirectUrl, title) =>
    apiClient.post('/v1/settings/card-guarantee/connect', { redirect_url: redirectUrl, title }),
  refresh: () => apiClient.post('/v1/settings/card-guarantee/refresh', {}),
};

export default cardGuaranteeService;
